import { DIALOG_TYPE, DOCUMENT_TYPE } from '../define/global';
import ga from './gaConnect';

export const sendMoveHomeGAData = (type, dialogType) => {
  let action = undefined;
  switch (type) {
    case DOCUMENT_TYPE.HWP:
      action = '웹한글바로가기';
      break;
    case DOCUMENT_TYPE.SHEET:
      action = '웹시트바로가기';
      break;
    case DOCUMENT_TYPE.SLIDE:
      action = '웹슬라이드바로가기';
      break;
    case DOCUMENT_TYPE.WORD:
      action = '웹워드바로가기';
      break;
    default:
      return;
  }

  let label = undefined;
  switch (dialogType) {
    case DIALOG_TYPE.DIALOG_OPEN_DOCUMENT:
      label = '시작화면';
      break;
    case DIALOG_TYPE.DIALOG_INSTALL_DOCUMENT:
      label = '전체서비스';
      break;
    default:
      return;
  }

  ga.event({ category: '이동', action, label });
};
